import App from 'next/app';
import { DFPSlotsProvider } from 'react-dfp';
import { ApolloProvider } from '@apollo/client';
import { ResponsiveImageProvider } from '@blaze-cms/image-cdn-react';
import { withBlaze } from '@blaze-cms/nextjs-tools';
import { ToastProvider } from '@blaze-react/toaster';
import buildConfig from '../blaze.config';
import { Footer } from '../components';
import IndexPage from '../components/IndexPage';
import { RESPONSIVE_IMAGE_CONFIG } from '../constants';

import '../styles/sass/_fonts.scss';
import '../styles/globals.css';
import '../styles/sass/main.scss';

class MyApp extends App {
  render() {
    const { Component, pageProps, apolloClient, router } = this.props;

    return (
      <ApolloProvider client={apolloClient}>
        <ToastProvider>
          <DFPSlotsProvider dfpNetworkId={process.env.DFP_NETWORK_ID} lazyLoad collapseEmptyDivs>
            <ResponsiveImageProvider config={RESPONSIVE_IMAGE_CONFIG}>
              <IndexPage />
              <div className="site-container">
                <main className="main">
                  <Component {...pageProps} router={router} />
                </main>
                <Footer />
              </div>
            </ResponsiveImageProvider>
          </DFPSlotsProvider>
        </ToastProvider>
      </ApolloProvider>
    );
  }
}

export default withBlaze(MyApp, buildConfig);
